import { AnimalEvent } from "@homeleite/domain";

export class AnimalEventsUtils {
    static readonly MATING_DATE: number = 260;
    static readonly ABORTION_ANIMAL_BIRTHDATE_DATE: number = 45;
    static readonly MATING_ANIMAL_BIRTHDATE_MONTH: number = 10;
    static readonly CHILDBIRTH_ANIMAL_BIRTHDATE_MONTH: number = 17;
    static readonly DRY_ANIMAL_BIRTHDATE_MONTH: number = 20;
    static readonly PREGNANCY_ANIMAL_BIRTHDATE_MONTH: number = 10;

    static getLastEventDate(animalEvents: AnimalEvent[]) {
        return animalEvents
            .at(-1)
            .date
    }
}
